import _ from 'lodash';
import { RequestStatus } from '../../enums';
import { makeAsyncReducerHandlers } from '../../helpers';
import {
  BooksActionTypes,
  ProjectsActionTypes,
  ChaptersActionTypes,
  InterviewsActionTypes,
  PhotosActionTypes,
} from '../../actions/types';
import BookHelpers from '../helpers/books.helpers';

const fetchChaptersAndResourcesByProjectId = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchChaptersAndResourcesByProjectId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getBookSampleAndResourcesByProjectId = makeAsyncReducerHandlers(
  ProjectsActionTypes.getBookSampleAndResourcesByProjectId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchChaptersAndResourcesByUser = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchChaptersAndResourcesByUser,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getBookSampleAndResourcesByUser = makeAsyncReducerHandlers(
  ProjectsActionTypes.getBookSampleAndResourcesByUser,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const submitBookDraftToEditorByWriter = makeAsyncReducerHandlers(
  BooksActionTypes.submitBookDraftToEditorByWriter,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    // TODO: replace by a new book instead merging when versions will be fetched separately
    const updatedBook = _.merge({}, state.items[0], action.payload.book);
    if (action.payload.book?.unfinishedChapters) {
      updatedBook.unfinishedChapters = action.payload.book.unfinishedChapters;
    }
    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const sendBookDraftToCustomerByEditor = makeAsyncReducerHandlers(
  BooksActionTypes.sendBookDraftToCustomerByEditor,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    // TODO: replace by a new book instead merging when versions will be fetched separately
    const updatedBook = _.merge({}, state.items[0], action.payload.book);
    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const approveBookDraftByCustomer = makeAsyncReducerHandlers(
  BooksActionTypes.approveBookDraftByCustomer,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    // TODO: replace by a new book instead merging when versions will be fetched separately
    const updatedBook = _.merge({}, state.items[0], action.payload.book);
    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const sendBookDraftCustomerFeedback = makeAsyncReducerHandlers(
  BooksActionTypes.sendBookDraftCustomerFeedback,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    // TODO: replace by a new book instead merging when versions will be fetched separately
    const updatedBook = _.merge({}, state.items[0], action.payload.book);
    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const sendBookDraftEditorFeedback = makeAsyncReducerHandlers(
  BooksActionTypes.sendBookDraftEditorFeedback,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    // TODO: replace by a new book instead merging when versions will be fetched separately
    const updatedBook = _.merge({}, state.items[0], action.payload.book);
    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const sendBookOutlineEditorFeedback = makeAsyncReducerHandlers(
  BooksActionTypes.sendBookOutlineEditorFeedback,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    // TODO: replace by a new book instead merging when versions will be fetched separately
    const updatedBook = _.merge({}, state.items[0], action.payload.book);
    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const sendBookOutlineCustomerFeedback = makeAsyncReducerHandlers(
  BooksActionTypes.sendBookOutlineCustomerFeedback,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    // TODO: replace by a new book instead merging when versions will be fetched separately
    const updatedBook = _.merge({}, state.items[0], action.payload.book);
    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const sendBookOutlineWriterFeedback = makeAsyncReducerHandlers(
  BooksActionTypes.sendBookOutlineWriterFeedback,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { book = {} } = action.payload;
    const updatedBook = _.merge({}, state.items.find(item => item._id === book._id), book);
    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const updateSpecificField = makeAsyncReducerHandlers(
  BooksActionTypes.updateSpecificField,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const updatedBook = _.merge({}, state.items.find(({ _id }) => _id === action.payload?.book?._id), action.payload.book);
    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const submitBookDraftToEditorByDevelopmentalEditor = makeAsyncReducerHandlers(
  BooksActionTypes.submitBookDraftToEditorByDevelopmentalEditor,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const sendDraftToCustomerByWriter = makeAsyncReducerHandlers(
  BooksActionTypes.sendDraftToCustomerByWriter,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const updatedBook = _.merge(
      {},
      state.items.find(({ _id }) => _id === action.payload?.book?._id),
      action.payload.book,
    );
    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const sendPDFToMyEmail = makeAsyncReducerHandlers(
  BooksActionTypes.sendPDFToMyEmail,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const saveChaptersChanges = makeAsyncReducerHandlers(
  ChaptersActionTypes.saveChaptersChanges,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const book = state.items.find(({ _id }) => _id === action.payload?.book?._id);
    book.bookSample = action.payload.book.bookSample;
    book.dedication = action.payload.book.dedication;
    book.bookTitleIdeas = action.payload.book.bookTitleIdeas;
    return {
      items: [book],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const saveBookSampleChanges = makeAsyncReducerHandlers(
  BooksActionTypes.saveBookSampleChanges,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const items = Array.from(state.items);
    const index = items.findIndex(item => item._id === action.payload.book._id);
    items.splice(index, 1, { ...items[index], ...action.payload.book });
    return {
      items,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchProjectOverviewDataByProjectId = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchProjectOverviewDataByProjectId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchProjectOverviewDataByCustomerId = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchProjectOverviewDataByCustomerId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchTimelineDataByCustomer = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchTimelineDataByCustomer,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const saveUserIdWhoReadNotificationDraftWasEdited = makeAsyncReducerHandlers(
  BooksActionTypes.saveUserIdWhoReadNotificationDraftWasEdited,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const sendPDFToPrinter = makeAsyncReducerHandlers(
  BooksActionTypes.sendPDFToPrinter,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const items = Array.from(state.items);
    const index = items.findIndex(item => item._id === action.payload.book._id);
    items.splice(index, 1, { ...items[index], ...action.payload.book });
    return {
      items,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchProofDataByProjectId = makeAsyncReducerHandlers(
  ChaptersActionTypes.fetchProofDataByProjectId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchProofDataByUserId = makeAsyncReducerHandlers(
  ChaptersActionTypes.fetchProofDataByUserId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const addCommentToBookSample = makeAsyncReducerHandlers(
  BooksActionTypes.addCommentToBookSample,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const {
      bookId,
      comment,
      bookSample,
    } = action.payload;

    return {
      items: BookHelpers.addBookSampleComment(
        state.items,
        {
          bookId,
          comment,
          bookSample,
        },
      ),
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const deleteCommentInBookSample = makeAsyncReducerHandlers(
  BooksActionTypes.deleteCommentInBookSample,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const {
      bookId,
      comment,
      bookSample,
    } = action.payload;

    return {
      items: BookHelpers.updateBookSampleComment(
        state.items,
        {
          bookId,
          comment,
          bookSample,
        },
      ),
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const resolveCommentInBookSample = makeAsyncReducerHandlers(
  BooksActionTypes.resolveCommentInBookSample,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const {
      bookId,
      comment,
      bookSample,
    } = action.payload;

    return {
      items: BookHelpers.updateBookSampleComment(
        state.items,
        {
          bookId,
          comment,
          bookSample,
        },
      ),
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const updateCommentInBookSample = makeAsyncReducerHandlers(
  BooksActionTypes.updateCommentInBookSample,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { bookId, comment } = action.payload;

    return {
      items: BookHelpers.updateBookSampleComment(
        state.items,
        {
          bookId,
          comment,
        },
      ),
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const addReplyToCommentInBookSample = makeAsyncReducerHandlers(
  BooksActionTypes.addReplyToCommentInBookSample,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const {
      bookId,
      commentId,
      reply,
    } = action.payload;

    const { comments = [] } = state.items.find(book => book._id === bookId).bookSample;

    const comment = comments.find(commentItem => commentItem._id === commentId);

    const updatedComment = { ...comment };
    updatedComment.replies.push(reply);

    return {
      items: BookHelpers.updateBookSampleComment(
        state.items,
        {
          bookId,
          comment,
        },
      ),
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const updateReplyToCommentInBookSample = makeAsyncReducerHandlers(
  BooksActionTypes.updateReplyToCommentInBookSample,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const {
      bookId,
      commentId,
      reply,
    } = action.payload;

    const books = [...state.items];
    const bookToUpdate = books.find(book => book._id === bookId);

    if (!bookToUpdate.bookSample.comments) {
      bookToUpdate.bookSample.comments = [];
    }

    const commentIndex = bookToUpdate.bookSample.comments.findIndex(comment => comment._id === commentId);
    const replyIndex = bookToUpdate
      .bookSample
      .comments[commentIndex]
      .replies.findIndex(replyItem => replyItem._id === reply._id);

    bookToUpdate
      .bookSample
      .comments[commentIndex]
      .replies[replyIndex] = reply;

    return {
      items: books,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const deleteOrUndoComments = makeAsyncReducerHandlers(
  BooksActionTypes.deleteOrUndoComments,
  state => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { bookId, comments, fieldName } = action.payload;

    const books = [...state.items];
    const updatedComments = [];
    const updatedBook = books.find(book => book._id === bookId);

    updatedBook[fieldName].comments.forEach((fieldComment) => {
      const commentIndex = comments.findIndex(comment => comment._id === fieldComment._id);
      const updatedComment = comments[commentIndex];

      if (updatedComment) {
        updatedComments.push(updatedComment);
      } else {
        updatedComments.push(fieldComment);
      }
    });

    updatedBook[fieldName].comments = updatedComments;

    return {
      items: books,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getBookAndResourcesByProjectId = makeAsyncReducerHandlers(
  BooksActionTypes.getBookAndResourcesByProjectId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getBookAndResourcesByCustomerId = makeAsyncReducerHandlers(
  BooksActionTypes.getBookAndResourcesByCustomerId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const approveCoverByCustomer = makeAsyncReducerHandlers(
  BooksActionTypes.approveCoverByCustomer,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getInterviewsInfo = makeAsyncReducerHandlers(
  InterviewsActionTypes.getInterviewsInfo,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const completeInterviewStage = makeAsyncReducerHandlers(
  BooksActionTypes.completeInterviewStage,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchPhotosAndResources = makeAsyncReducerHandlers(
  PhotosActionTypes.fetchPhotosAndResources,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const sendPhotosUploadInfo = makeAsyncReducerHandlers(
  PhotosActionTypes.sendPhotosUploadInfo,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const addPhotoByProjectId = makeAsyncReducerHandlers(
  PhotosActionTypes.addPhotoByProjectId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const addMultiplePhotos = makeAsyncReducerHandlers(
  PhotosActionTypes.addMultiplePhotos,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const updateMultiplePhotos = makeAsyncReducerHandlers(
  PhotosActionTypes.updateMultiplePhotos,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const updatePhoto = makeAsyncReducerHandlers(
  PhotosActionTypes.updatePhoto,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: !_.isEmpty(action.payload.book) ? [action.payload.book] : state.items,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const approveOutlineByEditor = makeAsyncReducerHandlers(
  BooksActionTypes.approveOutlineByEditor,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const approveOutlineByCustomer = makeAsyncReducerHandlers(
  BooksActionTypes.approveOutlineByCustomer,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const submitOutlineByWriter = makeAsyncReducerHandlers(
  BooksActionTypes.submitOutlineByWriter,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { book = {} } = action.payload;
    const updatedBook = _.merge({}, state.items.find(item => item._id === book._id), book);
    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const approveFinalProofByCustomer = makeAsyncReducerHandlers(
  BooksActionTypes.approveFinalProofByCustomer,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const approveFinalProofByEditor = makeAsyncReducerHandlers(
  BooksActionTypes.approveFinalProofByEditor,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const updatedBook = { ...state.items.find(({ _id }) => _id === action.payload?.book?._id), ...action.payload.book };
    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const editorSendDraftToDevelopmentalEditor = makeAsyncReducerHandlers(
  BooksActionTypes.editorSendDraftToDevelopmentalEditor,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const updatedBook = { ...state.items.find(({ _id }) => _id === action.payload?.book?._id), ...action.payload.book };
    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const editorSendDraftToProProofreader = makeAsyncReducerHandlers(
  BooksActionTypes.editorSendDraftToProProofreader,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const updatedBook = { ...state.items.find(({ _id }) => _id === action.payload?.book?._id), ...action.payload.book };
    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const uploadDocumentToGoogleDocx = makeAsyncReducerHandlers(
  BooksActionTypes.uploadDocumentToGoogleDocx,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { book = {} } = action.payload;
    const updatedBook = _.merge({}, state.items.find(item => item._id === book._id), book);
    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const updateCoverCopy = makeAsyncReducerHandlers(
  BooksActionTypes.updateCoverCopy,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { book = {} } = action.payload;
    const updatedBook = _.merge({}, state.items.find(item => item._id === book._id), book);

    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const updateCoverOptions = makeAsyncReducerHandlers(
  BooksActionTypes.updateCoverOptions,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { book = {} } = action.payload;
    const updatedBook = _.merge({}, state.items.find(item => item._id === book._id), book);

    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const chooseCoverPhoto = makeAsyncReducerHandlers(
  PhotosActionTypes.chooseCoverPhoto,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { book = {} } = action.payload;
    const updatedBook = _.merge({}, state.items.find(item => item._id === book._id), book);

    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const replaceCoverPhoto = makeAsyncReducerHandlers(
  PhotosActionTypes.replaceCoverPhoto,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { book = {} } = action.payload;
    const updatedBook = _.merge({}, state.items.find(item => item._id === book._id), book);

    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const deleteCoverPhotos = makeAsyncReducerHandlers(
  PhotosActionTypes.deleteCoverPhotos,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { book = {} } = action.payload;
    const updatedBook = _.merge({}, state.items.find(item => item._id === book._id), book);

    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const addCoverPhoto = makeAsyncReducerHandlers(
  PhotosActionTypes.addCoverPhoto,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { book = {} } = action.payload;
    const updatedBook = _.merge({}, state.items.find(item => item._id === book._id), book);

    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const onCloseOnboardingFeedbackModal = makeAsyncReducerHandlers(
  BooksActionTypes.onCloseOnboardingFeedbackModal,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { book = {} } = action.payload;
    const updatedBook = _.merge({}, state.items.find(item => item._id === book._id), book);

    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const addCommentToField = makeAsyncReducerHandlers(
  BooksActionTypes.addCommentToField,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const {
      bookId,
      comment,
      fieldDelta,
      fieldName,
    } = action.payload;

    return {
      items: BookHelpers.addBookSampleComment(
        state.items,
        {
          bookId,
          comment,
          [fieldName]: fieldDelta,
        },
        fieldName,
      ),
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const deleteCommentByFieldName = makeAsyncReducerHandlers(
  BooksActionTypes.deleteCommentByFieldName,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const {
      bookId,
      comment,
      fieldDelta,
      fieldName,
    } = action.payload;

    return {
      items: BookHelpers.updateBookSampleComment(
        state.items,
        {
          bookId,
          comment,
          [fieldName]: fieldDelta,
        },
        fieldName,
      ),
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const resolveCommentByFieldName = makeAsyncReducerHandlers(
  BooksActionTypes.resolveCommentByFieldName,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const {
      bookId,
      comment,
      fieldDelta,
      fieldName,
    } = action.payload;

    return {
      items: BookHelpers.updateBookSampleComment(
        state.items,
        {
          bookId,
          comment,
          [fieldName]: fieldDelta,
        },
        fieldName,
      ),
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const updateCommentByFieldName = makeAsyncReducerHandlers(
  BooksActionTypes.updateCommentByFieldName,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { bookId, comment, fieldName } = action.payload;


    const books = [...state.items];
    const bookIndexToUpdate = books.findIndex(book => book._id === bookId);
    const bookToUpdate = books[bookIndexToUpdate];

    const commentIndexToReplace = bookToUpdate[fieldName].comments.findIndex(c => c._id === comment._id);
    bookToUpdate[fieldName].comments[commentIndexToReplace] = comment;
    books.splice(bookIndexToUpdate, 1, { ...books[bookIndexToUpdate], ...bookToUpdate });

    return {
      items: books,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const addReplyToCommentByFieldName = makeAsyncReducerHandlers(
  BooksActionTypes.addReplyToCommentByFieldName,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const {
      bookId,
      commentId,
      reply,
      fieldName,
    } = action.payload;

    const books = [...state.items];
    const bookIndexToUpdate = books.findIndex(book => book._id === bookId);
    const bookToUpdate = books[bookIndexToUpdate];

    const { comments = [] } = bookToUpdate[fieldName];

    const commentIndexToUpdate = comments.findIndex(c => c._id === commentId);
    const comment = comments[commentIndexToUpdate];
    const updatedComment = { ...comment };
    updatedComment.replies.push(reply);

    bookToUpdate[fieldName].comments[commentIndexToUpdate] = updatedComment;
    books.splice(bookIndexToUpdate, 1, { ...books[bookIndexToUpdate], ...bookToUpdate });

    return {
      items: books,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const updateReplyToCommentByFieldName = makeAsyncReducerHandlers(
  BooksActionTypes.updateReplyToCommentByFieldName,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const {
      bookId,
      commentId,
      reply,
      fieldName,
    } = action.payload;

    const books = [...state.items];
    const bookToUpdate = books.find(book => book._id === bookId);

    if (!bookToUpdate[fieldName].comments) {
      bookToUpdate[fieldName].comments = [];
    }


    const commentIndex = bookToUpdate[fieldName].comments.findIndex(comment => comment._id === commentId);
    const replyIndex = bookToUpdate[fieldName]
      .comments[commentIndex]
      .replies.findIndex(replyItem => replyItem._id === reply._id);

    bookToUpdate[fieldName]
      .comments[commentIndex]
      .replies[replyIndex] = reply;

    return {
      items: books,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const approveBookSampleByCustomer = makeAsyncReducerHandlers(
  BooksActionTypes.approveBookSampleByCustomer,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const saveStyleSamplesChanges = makeAsyncReducerHandlers(
  BooksActionTypes.saveStyleSamplesChanges,
  (state) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const approveStyleSampleByCustomer = makeAsyncReducerHandlers(
  BooksActionTypes.approveStyleSampleByCustomer,
  (state) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);


const getProjectAndBookData = makeAsyncReducerHandlers(
  ProjectsActionTypes.getProjectAndBookData,
  (state) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const approveSampleByWriter = makeAsyncReducerHandlers(
  BooksActionTypes.approveSampleByWriter,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { book = {} } = action.payload;
    const updatedBook = _.merge({}, state.items.find((item) => item._id === book._id), book);
    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const approveSampleByEditor = makeAsyncReducerHandlers(
  BooksActionTypes.approveSampleByEditor,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { book = {} } = action.payload;
    const updatedBook = _.merge({}, state.items.find((item) => item._id === book._id), book);
    return {
      items: [updatedBook],
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchDataToEditProject = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchDataToEditProject,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const submitSpecification = makeAsyncReducerHandlers(
  BooksActionTypes.submitSpecification,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const saveSpecification = makeAsyncReducerHandlers(
  BooksActionTypes.saveSpecification,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const uploadCustomPDF = makeAsyncReducerHandlers(
  BooksActionTypes.uploadCustomPDF,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const uploadCustomCover = makeAsyncReducerHandlers(
  BooksActionTypes.uploadCustomCover,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const addCommentToPDF = makeAsyncReducerHandlers(
  BooksActionTypes.addCommentToPDF,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const resolvePdfComment = makeAsyncReducerHandlers(
  BooksActionTypes.resolvePdfComment,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const deletePdfComment = makeAsyncReducerHandlers(
  BooksActionTypes.deletePdfComment,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const addReplyToPdfComment = makeAsyncReducerHandlers(
  BooksActionTypes.addReplyToPdfComment,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const editPdfComment = makeAsyncReducerHandlers(
  BooksActionTypes.editPdfComment,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const approveDraftByContentTeam = makeAsyncReducerHandlers(
  BooksActionTypes.approveDraftByContentTeam,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.book],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const submitBookDraftToEditorByProProofreader = makeAsyncReducerHandlers(
  BooksActionTypes.submitBookDraftToEditorByProProofreader,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const proofRequestReview = makeAsyncReducerHandlers(
  BooksActionTypes.proofRequestReview,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

export default {
  fetchProjectOverviewDataByProjectId,
  fetchProjectOverviewDataByCustomerId,
  fetchTimelineDataByCustomer,
  fetchChaptersAndResourcesByProjectId,
  fetchChaptersAndResourcesByUser,
  submitBookDraftToEditorByWriter,
  sendBookDraftToCustomerByEditor,
  approveBookDraftByCustomer,
  sendBookDraftCustomerFeedback,
  sendBookDraftEditorFeedback,
  sendBookOutlineEditorFeedback,
  sendBookOutlineCustomerFeedback,
  sendBookOutlineWriterFeedback,
  updateSpecificField,
  sendDraftToCustomerByWriter,
  sendPDFToMyEmail,
  submitBookDraftToEditorByDevelopmentalEditor,
  saveChaptersChanges,
  saveUserIdWhoReadNotificationDraftWasEdited,
  addCommentToBookSample,
  deleteCommentInBookSample,
  resolveCommentInBookSample,
  updateCommentInBookSample,
  addReplyToCommentInBookSample,
  updateReplyToCommentInBookSample,
  deleteOrUndoComments,
  sendPDFToPrinter,
  fetchProofDataByProjectId,
  fetchProofDataByUserId,
  getBookAndResourcesByProjectId,
  getBookAndResourcesByCustomerId,
  approveCoverByCustomer,
  getInterviewsInfo,
  completeInterviewStage,
  fetchPhotosAndResources,
  sendPhotosUploadInfo,
  addPhotoByProjectId,
  addMultiplePhotos,
  updateMultiplePhotos,
  updatePhoto,
  approveOutlineByEditor,
  approveOutlineByCustomer,
  submitOutlineByWriter,
  approveFinalProofByCustomer,
  approveFinalProofByEditor,
  editorSendDraftToDevelopmentalEditor,
  editorSendDraftToProProofreader,
  uploadDocumentToGoogleDocx,
  updateCoverCopy,
  updateCoverOptions,
  chooseCoverPhoto,
  replaceCoverPhoto,
  deleteCoverPhotos,
  addCoverPhoto,
  onCloseOnboardingFeedbackModal,
  addCommentToField,
  deleteCommentByFieldName,
  resolveCommentByFieldName,
  updateCommentByFieldName,
  addReplyToCommentByFieldName,
  updateReplyToCommentByFieldName,
  getBookSampleAndResourcesByUser,
  getBookSampleAndResourcesByProjectId,
  saveBookSampleChanges,
  approveBookSampleByCustomer,
  saveStyleSamplesChanges,
  getProjectAndBookData,
  approveStyleSampleByCustomer,
  approveSampleByWriter,
  approveSampleByEditor,
  fetchDataToEditProject,
  submitSpecification,
  saveSpecification,
  uploadCustomPDF,
  uploadCustomCover,
  addCommentToPDF,
  resolvePdfComment,
  deletePdfComment,
  addReplyToPdfComment,
  editPdfComment,
  approveDraftByContentTeam,
  submitBookDraftToEditorByProProofreader,
  proofRequestReview,
};
